class BuildTags {
}
/** Hash the last time inertia was built */
BuildTags.buildHash = '5bbc3283';
/** Version of the package.json file the last time inertia was built */
BuildTags.packageVersion = '1203.0.4';
/** Time inertia was built in UTC */
BuildTags.buildTime = 'Thu, 15 Oct 2026 16:01:00 GMT';
/** Time inertia was built in Boston time */
BuildTags.buildTimeBoston = '2026-10-15 12:01:22 Boston';
/** Detailed build tags string */
BuildTags.detailed = 'BuildTags: 2026-10-15 12:01:22 Boston - 5bbc3283 - 1203.0.4';
export default BuildTags;
